import { useState } from "react";
import { Box, Fade } from "@mui/material";
import { useTranslation } from "next-i18next";
import { FADE_TRANSITION_PROPS } from "src/components-mui/base/fade/fade-transition.constants";
import { IWfHeadingProps, WfHeading } from "src/components-mui/base/wf-heading/wf-heading";
import { useRouterLocale } from "src/utils/router/use-router-locale";
import { addQuotationsToText } from "src/utils/string-util";

const headingStyles: IWfHeadingProps = {
    component: "h1",
    fontSize: { xs: "3xl", sm: "3xl", md: "4xl" },
    noWrap: true,
    sx: { wordBreak: "break-all", mb: 2 },
};

const takeOutOfFlow = (heading: HTMLElement) => {
    heading.style.position = "absolute";
};

type IAnimatedHeading = {
    headline: string;
    searchTerm?: string | string[];
    isMobile?: boolean;
};

export const AnimatedHeading = ({ searchTerm, headline, isMobile }: IAnimatedHeading) => {
    const { t } = useTranslation("extended-search");
    const { language } = useRouterLocale();
    const [lastSearchTerm, setLastSearchTerm] = useState(searchTerm);

    if (searchTerm && searchTerm !== lastSearchTerm) {
        setLastSearchTerm(searchTerm);
    }

    const displayedSearchTerm = searchTerm || lastSearchTerm;

    return (
        <>
            <Fade in={Boolean(searchTerm)} appear={false} mountOnEnter {...FADE_TRANSITION_PROPS} unmountOnExit onExit={takeOutOfFlow}>
                <Box sx={{ minWidth: 0 }}>
                    <WfHeading
                        {...headingStyles}
                        {...(isMobile ? { fontSize: "xl", sx: { ...headingStyles.sx, mb: 3 } } : { sx: { ...headingStyles.sx, pb: 1, mb: 1 } })}
                    >
                        {isMobile
                            ? addQuotationsToText(displayedSearchTerm as string, language)
                            : t("headlines.results-for", { searchTerm: displayedSearchTerm })}
                    </WfHeading>
                </Box>
            </Fade>
            <Fade in={!searchTerm} appear={false} mountOnEnter {...FADE_TRANSITION_PROPS} unmountOnExit onExit={takeOutOfFlow}>
                <Box sx={{ minWidth: 0 }}>
                    <WfHeading {...headingStyles}>{headline}</WfHeading>
                </Box>
            </Fade>
        </>
    );
};
